module.exports = __webpack_public_path__ + "static/scale-model-of-planz-park-in-bakersfield-california-14ddec70f503e97b9c1ef137fbd23a14.png";